import { render } from "./mister.vue?vue&type=template&id=635659b8"
import script from "./mister.vue?vue&type=script&lang=js"
export * from "./mister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__